import PartTypesSelect from '../../part-types-select';
import or from 'ember-truth-helpers/helpers/or';
import BvText from 'volta/components/bv-text';
import orElse from 'volta/helpers/or-else';
import tElse from 'volta/helpers/t-else';

import type { TemplateOnlyComponent } from '@ember/component/template-only';
import type { IJsonApiQuery } from 'volta/utils/api/jsonapi-types';

export interface ISkusPartTypeFilterDefinitionArgs {
  skuId?: string;
  horizontalPosition?: 'left' | 'right' | 'auto';
  beforeQuery?: (query: IJsonApiQuery) => IJsonApiQuery;
}
const FiltersSkusPartTypeFilterComponent = <template>
  {{! @glint-nocheck: not typesafe yet }}
  <PartTypesSelect
    @values={{@values}}
    @onChange={{@onChange}}
    @beforeQuery={{@componentArgs.beforeQuery}}
    @selectedPath='code'
    @labelHidden={{true}}
    @fill={{true}}
    @multiple={{true}}
    @matchTriggerWidth={{true}}
    @triggerClass={{@triggerClass}}
    @horizontalPosition={{or @componentArgs.horizontalPosition @horizontalPosition}}
    @dataName={{@name}}
    ...attributes
    as |pt|
  >
    <BvText>
      {{tElse pt.code (orElse pt.description pt.code)}}
    </BvText>
  </PartTypesSelect>
</template> satisfies TemplateOnlyComponent<ISkusPartTypeFilterDefinitionArgs>;
export default FiltersSkusPartTypeFilterComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Filters::SkusPartTypeFilter': typeof FiltersSkusPartTypeFilterComponent;
    'filters/skus-part-type-filter': typeof FiltersSkusPartTypeFilterComponent;
  }
}
